import { render } from "./template_management.html?vue&type=template&id=2aa5e779&external"
import script from "./template_management.js?vue&type=script&lang=js&external"
export * from "./template_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__